/* eslint-disable react/jsx-no-undef */
/*
 * @Author: zhang lin
 * @Date: 2022-04-08 13:09:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-08 15:39:02
 * @Description: file content
 */
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import classnames from 'classnames';
import { Form, Input, Row, Col, Radio, Select } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useIntl } from 'react-intl';
import { getLanguageApi } from 'root/services/manager';
import messages from 'root/pages/InstallSupos/messages';
import styles from './index.less';

import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { setIsMultiTenant, setDomain } from 'root/store/tenant/actions';

const { Option } = Select;
interface FCFormProps extends FormComponentProps {
  onSubmit: () => void;
  supOSConfigData: { [key: string]: any }; // 表单数据
  updateCpuAndMemoryCheckRes: (type: string, value: boolean) => void;
  failMes: string; // 测试ssh 失败
}
const Deploy = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { isMultiTenant, domain } = useSelector((state: reducerStates) => state.tenant);

  const errorHintMap = {
    cpuExceedHint: intl.formatMessage(messages.cpuExceedHint),
    memoryExceedHint: intl.formatMessage(messages.memoryExceedHint),
    cpuAndMemoryExceedHint: intl.formatMessage(messages.cpuAndMemoryExceedHint),
    cpuMinLimt: intl.formatMessage(messages.cpuMinLimt),
    memoryMinLimt: intl.formatMessage(messages.memoryMinLimt),
    cupAndMemoryMinLimt: intl.formatMessage(messages.cupAndMemoryMinLimt),
  };
  const { form, supOSConfigData, updateCpuAndMemoryCheckRes, failMes } = props;
  const { supos = {} } = supOSConfigData;
  const { reservedPortsForWeb = [] } = supos;
  const { getFieldDecorator, getFieldValue } = form;

  // 剩余Cpu和内存
  const [surplusCpu, setSurplusCpu] = useState(0);
  const [surplusMemory, setSurplusMemory] = useState(0);
  // 当前Cpu和内存
  const [currentAppCpu, setCurrentAppCpu] = useState(0);
  const [currentAppMemory, setCurrentAppMemory] = useState(0);
  const [currentPlatformCpu, setCurrentPlatformCpu] = useState(0);
  const [currentPlatformMemory, setCurrentPlatformMemory] = useState(0);
  // 是否超出
  const [isCpuExceed, setIsCpuExceed] = useState<boolean>(false);
  const [isMemoryExceed, setIsMemoryExceed] = useState<boolean>(false);
  const [languageList, setLanguageList] = useState<any>([]);
  useImperativeHandle(ref, () => ({
    form,
    isMemoryExceed,
    isCpuExceed,
  }));

  // 获取语言列表
  const initLanguage = async () => {
    await getLanguageApi().then((res: any) => {
      const { data } = res;
      setLanguageList(data);
    });
  };

  useEffect(() => {
    initLanguage();
  }, []);

  // 初始化
  useEffect(() => {
    setCurrentAppCpu(supos.appCpu || 3);
    setCurrentAppMemory(supos.appMem || 3);
    setCurrentPlatformCpu(supos.cpu || 13);
    setCurrentPlatformMemory(supos.mem || 27);
  }, [supos]);
  // 更新剩余可用cpu
  useEffect(() => {
    if (supos.cpuLimit === undefined) return;
    // 初始化后端给的数据可能没有，默认给个0
    const newSurplusCpu = supos.cpuLimit - (currentAppCpu || 0) - (currentPlatformCpu || 0);
    if (newSurplusCpu < 0) {
      unstable_batchedUpdates(() => {
        setSurplusCpu(newSurplusCpu);
        setIsCpuExceed(true);
      });
      updateCpuAndMemoryCheckRes('isCpuExceed', true);
    } else {
      unstable_batchedUpdates(() => {
        setSurplusCpu(newSurplusCpu);
        setIsCpuExceed(false);
      });
      updateCpuAndMemoryCheckRes('isCpuExceed', false);
    }
  }, [currentAppCpu, currentPlatformCpu, supos.cpuLimit]);
  // 更新剩余可用内存
  useEffect(() => {
    if (supos.memLimit === undefined) return;
    // 初始化后端给的数据可能没有，默认给个0
    const newSurplusMemory = supos.memLimit - (currentAppMemory || 0) - (currentPlatformMemory || 0);

    if (newSurplusMemory < 0) {
      unstable_batchedUpdates(() => {
        setSurplusMemory(newSurplusMemory);
        setIsMemoryExceed(true);
      });
      updateCpuAndMemoryCheckRes('isMemoryExceed', true);
    } else {
      unstable_batchedUpdates(() => {
        setSurplusMemory(newSurplusMemory);
        setIsMemoryExceed(false);
      });
      updateCpuAndMemoryCheckRes('isMemoryExceed', false);
    }
  }, [currentAppMemory, currentPlatformMemory, supos.memLimit]);
  const handleIptChange = (type: string, event: any) => {
    const {
      target: { value },
    } = event;
    switch (type) {
      case 'platformCpu':
        setCurrentPlatformCpu(value);
        break;
      case 'platformMem':
        setCurrentPlatformMemory(value);
        break;
      case 'AppCpu':
        setCurrentAppCpu(value);
        break;
      case 'AppMem':
        setCurrentAppMemory(value);
        break;
    }
  };

  // 切换租户模式选择
  const changeTenant = (ele: any) => {
    dispatch(setIsMultiTenant(ele.target.value));
  };

  // 设置泛域名
  const domainInput = (ele: any) => {
    dispatch(setDomain(ele.target.value));
  };

  // 平台配置内容
  const platform = () => {
    const cpuIptSty = classnames({
      [styles.cpuExceed]: isCpuExceed,
    });
    const memoryIptSty = classnames({
      [styles.memoryExceed]: isMemoryExceed,
    });
    return (
      <>
        <h4 className={styles.title}>{intl.formatMessage(messages.platformConfig)}</h4>
        <div className={cpuIptSty}>
          <Form.Item label={intl.formatMessage(messages.platformAvailableCPU)} colon={false}>
            {getFieldDecorator('cpu', {
              rules: [
                {
                  validator: (rule: any, value: string, callbackFn: Function) => {
                    if (!value) {
                      callbackFn(intl.formatMessage(messages.cpuNull));
                    }
                    if (Number(value) < 13) {
                      callbackFn(intl.formatMessage(messages.platformCpuMinError));
                    }
                    if (String(value).indexOf('.') >= 0) {
                      callbackFn(intl.formatMessage(messages.integerRequired));
                    }
                    callbackFn();
                  },
                },
              ],
              initialValue: supos['cpu'] || 13,
            })(
              <Input
                type="number"
                suffix="vC"
                width="300px"
                onBlur={handleIptChange.bind(null, 'platformCpu')}
                maxLength="64"
              />,
            )}
            <span className={styles.tip}>≥13vC</span>
          </Form.Item>
        </div>
        <div className={memoryIptSty}>
          <Form.Item label={intl.formatMessage(messages.platformAvailableMemory)} colon={false}>
            {getFieldDecorator('mem', {
              rules: [
                {
                  validator: (rule: any, value: string, callbackFn: Function) => {
                    if (!value) {
                      callbackFn(intl.formatMessage(messages.memoryNull));
                    }
                    if (Number(value) < 27) {
                      callbackFn(intl.formatMessage(messages.platformMemoryMinError));
                    }
                    if (String(value).indexOf('.') >= 0) {
                      callbackFn(intl.formatMessage(messages.integerRequired));
                    }
                    callbackFn();
                  },
                },
              ],
              initialValue: supos.mem || 27,
            })(
              <Input
                className={memoryIptSty}
                type="number"
                suffix="G"
                onBlur={handleIptChange.bind(null, 'platformMem')}
                maxLength="64"
              />,
            )}
            <span className={styles.tip}>≥27G</span>
          </Form.Item>
          {/* <div className={styles.systemTip}>{intl.formatMessage(messages.systemTip)}</div> */}
        </div>
        <h4 className={styles.title}>{intl.formatMessage(messages.AppConfig)}</h4>
        <div className={cpuIptSty}>
          <Form.Item label={intl.formatMessage(messages.AppAvailableCPU)} colon={false}>
            {getFieldDecorator('appCpu', {
              rules: [
                {
                  validator: (rule: any, value: string, callbackFn: Function) => {
                    if (!value) {
                      callbackFn(intl.formatMessage(messages.cpuNull));
                    }
                    if (Number(value) < 3) {
                      callbackFn(intl.formatMessage(messages.AppCpuMinError));
                    }
                    if (String(value).indexOf('.') >= 0) {
                      callbackFn(intl.formatMessage(messages.integerRequired));
                    }
                    callbackFn();
                  },
                },
              ],
              initialValue: supos['appCpu'] || 3,
            })(
              <Input
                className={cpuIptSty}
                type="number"
                suffix="vC"
                width="300px"
                onBlur={handleIptChange.bind(null, 'AppCpu')}
                maxLength="64"
              />,
            )}
            <span className={styles.tip}>≥3vC</span>
          </Form.Item>
        </div>
        <div className={memoryIptSty}>
          <Form.Item label={intl.formatMessage(messages.AppAvailableMemory)} colon={false}>
            {getFieldDecorator('appMem', {
              rules: [
                {
                  validator: (rule: any, value: string, callbackFn: Function) => {
                    if (!value) {
                      callbackFn(intl.formatMessage(messages.memoryNull));
                    }
                    if (Number(value) < 3) {
                      callbackFn(intl.formatMessage(messages.AppMemoryMinError));
                    }
                    if (String(value).indexOf('.') >= 0) {
                      callbackFn(intl.formatMessage(messages.integerRequired));
                    }
                    callbackFn();
                  },
                },
              ],
              initialValue: supos.appMem || 3,
            })(
              <Input
                className={memoryIptSty}
                type="number"
                suffix="G"
                onBlur={handleIptChange.bind(null, 'AppMem')}
                maxLength="64"
              />,
            )}
            <span className={styles.tip}>≥3G</span>
          </Form.Item>
        </div>
      </>
    );
  };
  // 授权信息内容
  const authorization = () => {
    return (
      <>
        <h4 className={styles.title}>{intl.formatMessage(messages.authorization)}</h4>
        <Form.Item label={intl.formatMessage(messages.licensingInstalled)} colon={false}>
          {getFieldDecorator('licensingInstalled', {
            initialValue: supos['licensingInstalled'] !== undefined ? supos['licensingInstalled'] : true,
          })(
            <Radio.Group>
              <Radio value={true}>{intl.formatMessage(messages.installed)}</Radio>
              <Radio value={false}>{intl.formatMessage(messages.noInstall)}</Radio>
            </Radio.Group>,
          )}
        </Form.Item>
        <Form.Item label={intl.formatMessage(messages.sameServer)} colon={false}>
          {getFieldDecorator('sameServerWithOps', {
            initialValue: supos['sameServerWithOps'] !== undefined ? supos['sameServerWithOps'] : true,
          })(
            <Radio.Group>
              <Radio value={true}>{intl.formatMessage(messages.local)}</Radio>
              <Radio value={false}>{intl.formatMessage(messages.noLocal)}</Radio>
            </Radio.Group>,
          )}
        </Form.Item>
        {!form.getFieldValue('sameServerWithOps') ? (
          <>
            <Form.Item label={intl.formatMessage(messages.authorizedDogAddress)} colon={false}>
              {getFieldDecorator('host', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.serverNull),
                  },
                  {
                    message: intl.formatMessage(messages.serverError),
                    pattern: new RegExp(
                      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(:([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]))?$/,
                    ),
                  },
                ],
                initialValue: supos['host'],
              })(<Input autoComplete="off" maxLength="64" />)}
            </Form.Item>

            {!form.getFieldValue('licensingInstalled') && (
              <>
                <Form.Item label={intl.formatMessage(messages.sshPort)} colon={false}>
                  {getFieldDecorator('lincenseSSHPort', {
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage(messages.sshPortNull),
                      },
                      {
                        pattern: new RegExp(/^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))$/),
                        message: intl.formatMessage(messages.portError),
                      },
                    ],
                    initialValue: supos['lincenseSSHPort'],
                  })(<Input maxLength="64" />)}
                </Form.Item>
                <Form.Item label={intl.formatMessage(messages.username)} colon={false}>
                  {getFieldDecorator('user', {
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage(messages.usernameNull),
                      },
                    ],
                    initialValue: 'root',
                  })(<Input disabled />)}
                </Form.Item>
                <Form.Item label={intl.formatMessage(messages.password)} colon={false}>
                  {getFieldDecorator('password', {
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage(messages.passwordNull),
                      },
                    ],
                    initialValue: supos['password'],
                  })(<Input.Password autoComplete="new-password" maxLength="64" />)}
                </Form.Item>
              </>
            )}
          </>
        ) : null}
      </>
    );
  };

  // 租户
  const tenantMode = () => {
    return (
      <div>
        <h4 className={styles.title}>{intl.formatMessage(messages.tenantModeConfig)}</h4>
        <Form.Item label={intl.formatMessage(messages.mode)} colon={false}>
          {getFieldDecorator('isMultiTenant', { initialValue: isMultiTenant })(
            <Radio.Group onChange={changeTenant}>
              <Radio value={false}>{intl.formatMessage(messages.singleTenant)}</Radio>
              {/* <Radio value={true}>{intl.formatMessage(messages.multitenancy)}</Radio> */}
            </Radio.Group>,
          )}
        </Form.Item>
        {getFieldValue('isMultiTenant') && (
          <Form.Item label={`${intl.formatMessage(messages.universalDomainName)}`} colon={false}>
            {getFieldDecorator('domain', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.nameNull),
                },
                {
                  pattern: new RegExp(
                    /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
                  ),
                  message: intl.formatMessage(messages.nameError),
                },
              ],
              initialValue: domain,
            })(
              <Input
                autoComplete="off"
                maxLength="64"
                placeholder={intl.formatMessage(messages.nameTip)}
                onInput={domainInput}
              />,
            )}
          </Form.Item>
        )}
      </div>
    );
  };
  // 端口信息内容呢
  const port = () => {
    return (
      <>
        <Form.Item label={intl.formatMessage(messages.webAccessPort)} colon={false}>
          {getFieldDecorator('webPort', {
            rules: [
              {
                required: true,
                message: intl.formatMessage(messages.webAccessPortNull),
              },
              {
                validator: (rule: any, value: string, callbackFn: Function) => {
                  const result = reservedPortsForWeb.some((item: any) => item === value);
                  if (result) {
                    callbackFn(intl.formatMessage(messages.reservedPortError));
                  }
                  callbackFn();
                },
              },
              {
                message: intl.formatMessage(messages.portError),
                pattern: new RegExp(/^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))$/),
              },
            ],
            initialValue: supos['webPort'],
          })(<Input maxLength="64" />)}
        </Form.Item>
        {/* <Form.Item label={intl.formatMessage(messages.sshPort)} colon={false}>
          {getFieldDecorator('sshPort', {
            rules: [
              {
                required: true,
                message: intl.formatMessage(messages.sshPortNull),
              },
              {
                pattern: new RegExp(/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/),
                message: intl.formatMessage(messages.portError),
              },
            ],
            initialValue: supos['sshPort'],
          })(<Input maxLength="64" />)}
        </Form.Item> */}
      </>
    );
  };

  // 语言信息
  const language = () => {
    let initialValue = '';
    if (languageList.length) {
      initialValue = languageList[0].name;
    }

    return (
      <Form.Item label={intl.formatMessage(messages.language)} colon={false}>
        {getFieldDecorator('OSLANG', {
          initialValue:
            supos.OSLANG || languageList?.find((item: any) => item.name === supos.OSLANG)?.name || initialValue,
        })(
          <Select>
            {languageList.map((item: any) => {
              return (
                <Option key={item.cnName} value={item.name}>
                  {item.cnName}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
    );
  };
  let errorHint = '';

  if (isCpuExceed && isMemoryExceed) {
    errorHint = errorHintMap['cpuAndMemoryExceedHint'];
  } else if (isCpuExceed) {
    errorHint = errorHintMap['cpuExceedHint'];
  } else if (isMemoryExceed) {
    errorHint = errorHintMap['memoryExceedHint'];
  }

  if (supos.memLimit < 27) {
    errorHint = errorHintMap['memoryMinLimt'];
  }

  if (supos.cpuLimit < 13) {
    errorHint = errorHintMap['cpuMinLimt'];
  }
  if (supos.cpuLimit < 13 && supos.memLimit < 27) {
    errorHint = errorHintMap['cupAndMemoryMinLimt'];
  }

  return (
    <Form labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
      <div className={styles.box}>
        <div className={styles.header}>
          <Row>
            <Col span={12}>
              <div className={styles.text}>{intl.formatMessage(messages.totalServerQuota)}</div>
              <div className={styles.wrap}>
                <span>CPU:{supos.cpuLimit}vC</span>
                <span>
                  {intl.formatMessage(messages.memory)}:{supos.memLimit}G
                </span>
              </div>
            </Col>
            <Col span={12}>
              <div className={styles.text}>{intl.formatMessage(messages.remainingAvailableQuota)}</div>
              <div className={styles.wrap}>
                <span>CPU:{surplusCpu}vC</span>
                <span>
                  {intl.formatMessage(messages.memory)}:{surplusMemory}G
                </span>
              </div>
            </Col>
          </Row>
        </div>
        {errorHint && <div className={styles.errorHint}>{errorHint}</div>}
        <div className={styles['form-wrap']}>{platform()}</div>
      </div>
      <div className={styles.box}>
        <div className={styles['form-wrap2']}>{port()}</div>
      </div>
      <div className={styles.box}>
        <div className={styles['form-wrap2']}>{language()}</div>
      </div>
      <div className={styles.box}>
        <div className={styles['form-wrap2']}>{tenantMode()}</div>
      </div>

      <div className={styles.box}>
        <div className={styles['form-wrap']}>{authorization()}</div>
        {failMes && !form.getFieldValue('sameServerWithOps') && (
          <span className={styles.failed}>
            {intl.formatMessage(messages.sshLinkFail)}：{failMes}
          </span>
        )}
      </div>
    </Form>
  );
});
export default Form.create()(Deploy);
